import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Header from './Header';
import { toggleAppDrawer } from '../../store/action/common-actions';
import { useQuery } from 'react-query';

const HeaderContainer = ({ queryClient }) => {
  const dispatch = useDispatch();
  const { data: uiDetails } = useQuery('/admin/uidetails');
  const version = uiDetails?.portal_version;
  const releasedDate = uiDetails?.portal_release_date_en;
  const username = uiDetails?.profile_name;
  const isAppDrawerOpen = useSelector((state) => state.commonStates.isAppDrawerOpen);
  const handleAppDrawerToggle = () => {
    dispatch(toggleAppDrawer());
  };

  return (
    <Header
      version={version}
      releasedDate={releasedDate}
      username={username}
      isAppDrawerOpen={isAppDrawerOpen}
      onAppDrawerToggle={handleAppDrawerToggle}
      queryClient={queryClient}
    />
  );
};
export default HeaderContainer;
